import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';
import { getCourseBundleMaterials } from 'src/common/services/courseBundle';

export const useCourseBundleMaterialsQuery = (courseBundleId?: number) => {
  const { key, isAuthenticated } = useCurrentUserKeyEnhancer([
    QueryKey.CourseBundleMaterials,
    courseBundleId,
  ]);

  return useQuery(key, () => getCourseBundleMaterials(courseBundleId!, isAuthenticated), {
    enabled: !!courseBundleId,
  });
};
